import React from "react";
import {
  StyledArrowUpwardIcon,
  StyledCompactCard,
  StyledDashboardCard,
  StyledDashboardChangeText,
  StyledDashboardCount,
  StyledDashboardFooter,
  StyledDashboardIconContainer,
  StyledDashboardCompactIconContainer,
  StyledDashboardTitle,
  StyledBox,
} from "./style";

const AdminStatisticsCard = ({ title, count, Icon, changePercent, hideFooter }) => {
  return (
    <StyledDashboardCard>
      <StyledDashboardIconContainer>
        {typeof Icon === "string" ? <img src={Icon} alt={title} /> : <Icon />}
      </StyledDashboardIconContainer>

      <StyledDashboardTitle>{title}</StyledDashboardTitle>
      <StyledDashboardCount>{count}</StyledDashboardCount>

      {!hideFooter && (
        <StyledDashboardFooter>
          <StyledArrowUpwardIcon />
          <StyledDashboardChangeText>
            {changePercent}% vs Yesterday
          </StyledDashboardChangeText>
        </StyledDashboardFooter>
      )}
    </StyledDashboardCard>
  );
};

const CompactStatisticsCard = ({ title, count, Icon }) => {
  return (
    <StyledCompactCard>
      <StyledDashboardTitle>{title}</StyledDashboardTitle>
      <StyledBox>
      <StyledDashboardCompactIconContainer>
        {typeof Icon === "string" ? <img src={Icon} alt={title} /> : <Icon />}
      </StyledDashboardCompactIconContainer>
      <StyledDashboardCount>{count}</StyledDashboardCount>
      </StyledBox>
    </StyledCompactCard>
  );
};

export { AdminStatisticsCard, CompactStatisticsCard };